/* eslint-disable react/prop-types */

import React from 'react';
import { Card, CardFooter, CardBody, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { Button, Field, useFeatures, Form, useFetch } from '@cordata/buffet';
import { find } from 'lodash';

import useDuplicate from '~/utils/duplicate/hook';
import {
  adminInstance as axios,
  toastSuccess,
} from '~/utils';

const validationSchema = Yup.object().shape({
  carrierName: Yup.string().required(),
});

const initialValues = {
  carrierName: '',
  insuranceCarrierTypeUid: {},
};

const InsuranceCarriersForm = ({
  data,
}) => {
  const { hasAppKickstarter } = useFeatures();
  const history = useHistory();
  const [status, insuranceCarrierTypes] = useFetch('reference-admin/reference-insurance-carrier-type', { instance: 'p', params: { sort: 'insurance-carrier-type-name' } });
  const { handleDuplicateCheck } = useDuplicate({ api: 'admin/insurance-carrier', labelKey: 'carrierName' });

  return (
    <Form
      displayName="InsuranceCarriersForm"
      enableReinitialize

      initialValues={{
        ...initialValues,
        id: data && data.id,
        ...(data && data.attributes),
        insuranceCarrierType: data && find(insuranceCarrierTypes, ['id', data.attributes.insuranceCarrierTypeUid]),
      }}
      validationSchema={validationSchema}

      onSubmit={(values, { setSubmitting, setErrors }) => {
        const p = {
          ...values,
          orgUid: localStorage.getItem('org'),
          insuranceCarrierTypeUid: values.insuranceCarrierType && values.insuranceCarrierType.id,
        };

        const method = values.id ? 'put' : 'post';
        const url = `/insurance-carrier${values.id ? `/${values.id}` : ''}`;

        axios[method](url, p)
          .then(() => toastSuccess())
          .then(() => history.push('/admin/insurance-carriers'))
          .catch((e) => {
            setErrors({
              server: e.response.data,
              ...e.response.data.errors,
            });
          })
          .then(() => setSubmitting(false));
      }}
    >
      {({
        values,
        errors,
        isSubmitting,
        submitCount,
        handleBlur,
      }) => (
        <Card>
          <CardBody>
            { submitCount >= 1 && errors && errors.orgUid && <Alert color="danger">We are unable to complete this action.<hr />Organization is required.</Alert> }

            <Field
              name="carrierName"
              required
              onBlur={() => {
                if (!values.id) {
                  handleDuplicateCheck(values);
                }

                handleBlur('carrierName');
              }}
            />

            <Field
              name="insuranceCarrierType"
              label="Carrier Type"
              type="select"
              options={insuranceCarrierTypes}
              getOptionValue={o => o.id}
              getOptionLabel={o => o.attributes.insuranceCarrierTypeLabel}
              loading={status === 'loading'}
            />

            {hasAppKickstarter && (
            <Field
              name="id"
              label="Insurance Carrier Uid"
              placeholder=" "
              disabled
            />
          )}
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="cancel"
                disabled={isSubmitting}
                tag={Link}
                to="/admin/insurance-carriers"
              >
                Cancel
              </Button>

              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Working ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

export default InsuranceCarriersForm;
